import { render } from "./TicketsModal.vue?vue&type=template&id=ca468070&scoped=true&lang=pug"
import script from "./TicketsModal.vue?vue&type=script&lang=ts"
export * from "./TicketsModal.vue?vue&type=script&lang=ts"

import "./TicketsModal.vue?vue&type=style&index=0&id=ca468070&lang=scss"
import "./TicketsModal.vue?vue&type=style&index=1&id=ca468070&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ca468070"

export default script